<template>
    <div class="newPage">
        <div class="content">
            <!--区域配置-->
            <!--<breadcrumb></breadcrumb>-->
            <div style="padding: 20px">
                <el-row :gutter="10" class="mb8">
                    <el-col :span="1.5">
                        <el-button type="primary"
                                   icon="el-icon-plus"
                                   size="mini"
                                   @click="add">新增
                        </el-button>
                    </el-col>
                </el-row>

            </div>
            <div v-if="tableData.list">
                <el-table v-loading="loading"
                          :data="tableData.list"
                >


                    <el-table-column label="展示名称" align="center" prop="title"/>
                    <el-table-column label="区域名称" align="center" prop="reportTitle"/>
                    <el-table-column label="城市" align="center" prop="citys"/>
                    <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
                        <template slot-scope="scope">
                            <el-button
                                    size="mini"
                                    type="text"
                                    icon="el-icon-edit"
                                    @click="handleUpdate(scope.row)"

                            >修改
                            </el-button>
                            <el-button
                                    size="mini"
                                    type="text"
                                    icon="el-icon-delete"
                                    @click="handleDelete(scope.row)"
                            >删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <pagination
                    v-show="tableData.totalCount>0"
                    :total="tableData.totalCount"
                    :page.sync="queryParams.page"
                    :limit.sync="queryParams.pageSize"
                    @pagination="getList"
            />
        </div>


        <el-dialog title="区域配置" :visible.sync="open" width="80%" append-to-body>
            <el-form ref="form" :model="form" :rules="rules" label-width="80px">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="区域名称" prop="reportTitle">
                            <el-input v-model="form.reportTitle" placeholder="请输入区域名称"/>
                        </el-form-item>
                        <el-form-item label="展示名称" prop="title">
                            <el-input v-model="form.title" placeholder="请输入展示名称"/>
                        </el-form-item>
                        <el-form-item label="城市" prop="citys">
                            <el-cascader
                                    v-model="form.citys"
                                    :options="cityList"
                                    :props="cityProps"
                                    clearable
                                    collapse-tags
                                    @remove-tag="removetag"
                            ></el-cascader>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitForm">确 定</el-button>
                <el-button @click="cancel">取 消</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>

    import url from "../../../utils/UrlApi"


    export default {
        name: "regionalConfig",
        components: {},
        data() {
            return {
                open: false,
                loading: false,
                tableData: {
                    totalCount: 0
                },
                form: {
                    id: null,
                    title: null,
                    reportTitle: null,
                    citys: [],
                },
                queryParams: {
                    page: 1,
                    pageSize: 10
                },
                rules: {
                    reportTitle: [
                        {required: true, message: "区域名称不能为空", trigger: "blur"}
                    ],
                    title: [
                        {required: true, message: "菜单名称不能为空", trigger: "blur"}
                    ],
                    citys: [
                        {required: true, message: "城市不能为空", trigger: "change"}
                    ],
                },
                cityList: [],
                cityProps: {
                    multiple: true,
                    emitPath: false,
                    label: "lable",
                    value: "lable"
                },
            }
        },
        mounted() {
            this.getCityList()
            this.getList()
        },
        methods: {
            restart() {
                this.form = {
                    id: null,
                    title: null,
                    reportTitle: null,
                    citys: [],
                }
            },
            getList() {
                let data = this.queryParams
                this.$http.get(url.reportAreaList, {
                    params: data
                }).then(res => {
                    if (res.data.code === '200') {
                        this.tableData = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            getCityList() {
                let data = {}
                this.$http.get(url.addressAddr, {
                    params: data
                }).then(res => {
                    if (res.data.code === '200') {
                        this.cityList = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            removetag(value) {
                console.log(value)
            },
            handleUpdate(row) {

                let data = {
                    id: row.id
                }
                this.$http.get(url.reportAreaInfo, {
                    params: data
                }).then(res => {
                    if (res.data.code === '200') {
                        this.form = res.data.data;

                        this.form.citys = res.data.data.citys.split(',')

                        this.open = true;
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            handleDelete(row) {
                let self = this
                // this.$confirm({
                //     title: '重要操作！',
                //     content: '确定要删除此条数据吗？',
                //     onOk() {
                //         let data = {
                //             id: row.id
                //         }
                //         self.$http.post(url.reportAreaDelete, data).then(res => {
                //             if (res.data.code === '200') {
                //                 self.$message.success('删除成功')
                //                 self.getList()
                //             } else {
                //                 self.$message.error(res.data.message)
                //             }
                //         })
                //     },
                //     onCancel() {
                //
                //     }
                // });
                this.$confirm('确定要删除此条数据吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let data = {
                        id: row.id
                    }
                    self.$http.post(url.reportAreaDelete, data).then(res => {
                        if (res.data.code === '200') {
                            self.$message.success('删除成功')
                            self.getList()
                        } else {
                            self.$message.error(res.data.message)
                        }
                    })
                }).catch(() => {

                });

            },
            submitForm() {
                this.$refs["form"].validate(valid => {
                    if (valid) {

                        let data = JSON.parse(JSON.stringify(this.form))
                        data.citys = this.form.citys.join()
                        if (this.form.id) {
                            // 修改
                            this.$http.post(url.reportAreaUpdate, data).then(res => {
                                if (res.data.code === '200') {
                                    this.$message.success('修改成功')
                                    this.cancel()
                                } else {
                                    this.$message.error(res.data.message)
                                }
                            })
                        } else {
                            // 新增

                            this.$http.post(url.reportAreaSave, data).then(res => {
                                if (res.data.code === '200') {
                                    this.$message.success('添加成功')
                                    this.cancel()
                                } else {
                                    this.$message.error(res.data.message)
                                }
                            })
                        }
                    }
                });
            },
            cancel() {

                this.getList()
                this.open = false
            },
            add() {
                this.restart()
                this.open = true
            },
        }
    }
</script>

<style scoped>

</style>